__turbopack_context__.v({
  "bot": "style-module-scss-module__HZsihW__bot",
  "disabled": "style-module-scss-module__HZsihW__disabled",
  "glitchText": "style-module-scss-module__HZsihW__glitchText",
  "top": "style-module-scss-module__HZsihW__top",
  "wrapper": "style-module-scss-module__HZsihW__wrapper",
});
